module.exports = __webpack_public_path__ + "08dfd7285a7c862639a8f570596c156f.MP3";